import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } }

  connect() {
    // Slide in
    requestAnimationFrame(() => {
      this.element.classList.remove("translate-y-[-1rem]", "opacity-0")
      this.element.classList.add("translate-y-0", "opacity-100")
    })

    this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.classList.remove("translate-y-0", "opacity-100")
    this.element.classList.add("translate-y-[-1rem]", "opacity-0")
    setTimeout(() => this.element.remove(), 200)
  }
}
